import isUrl from './isUrl';

const ERROR_MESSAGE = 'Input is not a valid secure (https) URL';

export default function isHttpsRule(value: unknown): string | true {
    return isUrl(['https'], ERROR_MESSAGE, value);
}
